module.exports = __webpack_public_path__ + "static/media/pry-resistant-door.f99649d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/pry-resistant-door.png
// module id = 1227
// module chunks = 0